export enum FeeCalculatorPortfolioLevel {
  No = "No",
  Family = "FamilyLevel",
  Account = "AccountLevel",
}
